<template>
    <div id="share_modal" class="modal-content modal-sm">
        <div class="modal-header p-b-0">
			<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
		</div>

        <div class="modal-body p-b-0 p-t-0">
            <div class="text-center">
                <h2 class="text-center m-b-30" v-if="!profile">Compartilhe este anúncio</h2>
                <h2 class="text-center m-b-30" v-else>Compartilhe esta página</h2>

                <img class="premium_img m-b-20" src="/images/share.svg" alt="" />

                <p v-if="!profile">Compartilhe este anúncio em suas redes sociais, ou o envie
                    para conhecidos buscando <b>quartos para alugar</b>.</p>

                <p v-else>Compartilhe seus anúncios em suas redes sociais, ou o envie
                    para conhecidos buscando <b>quartos para alugar</b>.</p>

                <div class="m-t-30 text-left">
                    <div>
                        <a id="fb_share" @click.prevent="fbShare()" class="btn btn-link text-dark" href="#"><i class="fab fa-facebook-f m-r-10"></i>Facebook</a>
                    </div>
                    <hr/>
                    <div>
						<a id="twt_share" @click.prevent="twitterShare()" class="btn btn-link text-dark" href="#"><i class="fab fa-twitter m-r-10"></i>Twitter</a>
                    </div>
                    <hr/>
                    <div>
						<a v-if="!profile" id="wpp_share" target="_blank" class="btn btn-link text-dark" :href="'https://api.whatsapp.com/send?text=Dá uma olhada neste anúncio no WebQuarto: ' + url + '%3Futm_source%3Dwhatsapp%26utm_medium%3Dsharing%26utm_campaign%3Dad_sharing_options'"><i class="fab fa-whatsapp m-r-10"></i>Whatsapp</a>
						<a v-else id="wpp_share" target="_blank" class="btn btn-link text-dark" :href="'https://api.whatsapp.com/send?text=Dá uma olhada nestes anúncios no WebQuarto: ' + url + '%3Futm_source%3Dwhatsapp%26utm_medium%3Dsharing%26utm_campaign%3Dad_sharing_options'"><i class="fab fa-whatsapp m-r-10"></i>Whatsapp</a>
                    </div>
                    <hr/>
                    <div>
						<button type="button" id="cpl_share" class="btn btn-link text-dark"><i class="fas fa-link m-r-10"></i>Copiar Link</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClipboardJS from '../../../../../../legacy/node_modules/clipboard';
export default {
    props: {
        profile : {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            url: ''
        }
    },
    methods: {
        fbShare: function () {
            const href = window.location.href + '?utm_source=facebook&utm_medium=sharing&utm_campaign=ad_sharing_options';
			
            FB.ui({
				method: 'share',
				href,
			}, function(){});
        },
        twitterShare: function () {
            const share_url = window.location.href + '?utm_source=twitter&utm_medium=sharing&utm_campaign=ad_sharing_options';
            const width  = 575,
				height = 400,
				left   = (window.innerWidth  - width)  / 2,
				top    = (window.innerHeight - height) / 2,
                url    = this.profile ? 'http://twitter.com/share?text=Dá uma olhada nestes anúncios no @WebQuarto: &url=' + share_url
                                        : 'http://twitter.com/share?text=Dá uma olhada neste anúncio no @WebQuarto: &url=' + share_url,
				opts   = 'status=1' +
						',width='  + width  +
						',height=' + height +
						',top='    + top    +
						',left='   + left;

			window.open(url, 'twitter', opts);
        },
    },
    created() {
        this.url = window.location.href;
    },
    mounted() {
        let share_url = window.location.href + '?utm_source=copy_link&utm_medium=sharing&utm_campaign=ad_sharing_options';

        let clip = new ClipboardJS('#cpl_share', {
            container: document.getElementById('share_modal'),
            text: function(trigger) {
                return share_url;
            }
        });
    }
}
</script>
<style lang="scss" scoped>
    img {
        width: 40px;
    }
    hr {
        margin: 10px 0;
    }
</style>
